document.documentElement.classList.add('js');


document.addEventListener('DOMContentLoaded', function () {

  /* ------------------------------
     MOBILE MENU
  ------------------------------ */

  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.main-nav');

  if (toggle && nav) {

    toggle.addEventListener('click', function () {

      var open =
        toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute(
        'aria-expanded',
        String(!open)
      );

      nav.classList.toggle(
        'is-open',
        !open
      );

    });

  }


  /* ------------------------------
     CART DRAWER
  ------------------------------ */

  var drawer =
    document.getElementById('CartDrawer');

  var overlay =
    document.getElementById('CartDrawerOverlay');

  var closeButton =
    document.querySelector('.cart-drawer-close');

  var drawerItems =
    document.getElementById('CartDrawerItems');

  var drawerSubtotal =
    document.getElementById('CartDrawerSubtotal');

  var drawerCount =
    document.getElementById('CartDrawerCount');


  function formatMoney(cents) {

    return new Intl.NumberFormat(
      'en-US',
      {
        style: 'currency',
        currency: 'USD'
      }
    ).format(cents / 100);

  }


  function openCartDrawer() {

    if (!drawer || !overlay) return;

    drawer.classList.add('is-open');
    overlay.classList.add('is-open');

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'cart-drawer-open'
    );

  }


  function closeCartDrawer() {

    if (!drawer || !overlay) return;

    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'cart-drawer-open'
    );

  }


  async function getCart() {

    var response =
      await fetch('/cart.js');

    return await response.json();

  }


  async function renderCart() {

    if (!drawerItems) return;

    var cart = await getCart();

    drawerItems.innerHTML = '';


    if (cart.item_count === 0) {

      drawerItems.innerHTML =
        '<div class="cart-drawer-empty">' +
          '<p>Your cart is empty.</p>' +
          '<a href="/collections/all">Continue shopping</a>' +
        '</div>';

    } else {

      cart.items.forEach(function (item) {

        var itemElement =
          document.createElement('div');

        itemElement.className =
          'cart-drawer-item';


        var imageHTML = '';

        if (item.image) {

          imageHTML =
            '<a href="' + item.url + '" class="cart-drawer-item-image">' +
              '<img src="' + item.image + '" alt="">' +
            '</a>';

        }


        itemElement.innerHTML =

          imageHTML +

          '<div class="cart-drawer-item-info">' +

            '<a href="' +
              item.url +
              '" class="cart-drawer-item-title">' +
              item.product_title +
            '</a>' +

            '<div class="cart-drawer-item-price">' +
              formatMoney(item.final_line_price) +
            '</div>' +

            '<div class="cart-drawer-quantity">' +

              '<button ' +
                'type="button" ' +
                'class="cart-quantity-minus" ' +
                'data-key="' +
                item.key +
              '">' +
                '−' +
              '</button>' +

              '<span>' +
                item.quantity +
              '</span>' +

              '<button ' +
                'type="button" ' +
                'class="cart-quantity-plus" ' +
                'data-key="' +
                item.key +
              '">' +
                '+' +
              '</button>' +

            '</div>' +

            '<button ' +
              'type="button" ' +
              'class="cart-drawer-remove" ' +
              'data-key="' +
              item.key +
            '">' +
              'Remove' +
            '</button>' +

          '</div>';


        drawerItems.appendChild(
          itemElement
        );

      });

    }


    if (drawerSubtotal) {

      drawerSubtotal.textContent =
        formatMoney(cart.total_price);

    }


    if (drawerCount) {

      drawerCount.textContent =
        '(' + cart.item_count + ')';

    }


    updateHeaderCartCount(
      cart.item_count
    );

  }


  async function changeQuantity(
    key,
    quantity
  ) {

    await fetch(
      '/cart/change.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json'
        },

        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      }
    );

    await renderCart();

  }


  function updateHeaderCartCount(count) {

    var possibleCounts =
      document.querySelectorAll(
        '.cart-count, [data-cart-count]'
      );

    possibleCounts.forEach(
      function (element) {
        element.textContent = count;
      }
    );

  }


  /* CLOSE DRAWER */

  if (closeButton) {

    closeButton.addEventListener(
      'click',
      closeCartDrawer
    );

  }


  if (overlay) {

    overlay.addEventListener(
      'click',
      closeCartDrawer
    );

  }


  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key === 'Escape') {
        closeCartDrawer();
      }

    }
  );


  /* QUANTITY + REMOVE */

  document.addEventListener(
    'click',
    async function (event) {

      if (
        event.target.classList.contains(
          'cart-quantity-plus'
        )
      ) {

        var key =
          event.target.dataset.key;

        var cart =
          await getCart();

        var item =
          cart.items.find(
            function (cartItem) {
              return cartItem.key === key;
            }
          );

        if (item) {

          await changeQuantity(
            key,
            item.quantity + 1
          );

        }

      }


      if (
        event.target.classList.contains(
          'cart-quantity-minus'
        )
      ) {

        var minusKey =
          event.target.dataset.key;

        var minusCart =
          await getCart();

        var minusItem =
          minusCart.items.find(
            function (cartItem) {
              return cartItem.key === minusKey;
            }
          );

        if (minusItem) {

          await changeQuantity(
            minusKey,
            Math.max(
              0,
              minusItem.quantity - 1
            )
          );

        }

      }


      if (
        event.target.classList.contains(
          'cart-drawer-remove'
        )
      ) {

        await changeQuantity(
          event.target.dataset.key,
          0
        );

      }

    }
  );


  /* ------------------------------
     AJAX ADD TO CART
  ------------------------------ */

  var productForms =
    document.querySelectorAll(
      'form[action*="/cart/add"]'
    );


  productForms.forEach(
    function (form) {

      form.addEventListener(
        'submit',
        async function (event) {

          event.preventDefault();

          var submitButton =
            form.querySelector(
              'button[type="submit"]'
            );

          if (submitButton) {
            submitButton.disabled = true;
          }


          try {

            var formData =
              new FormData(form);

            var response =
              await fetch(
                '/cart/add.js',
                {
                  method: 'POST',
                  body: formData,
                  headers: {
                    'Accept':
                      'application/json'
                  }
                }
              );


            if (!response.ok) {
              throw new Error(
                'Unable to add item to cart.'
              );
            }


            await renderCart();

            openCartDrawer();


          } catch (error) {

            console.error(error);

            alert(
              'There was a problem adding this item to your cart. Please try again.'
            );

          } finally {

            if (submitButton) {
              submitButton.disabled = false;
            }

          }

        }
      );

    }
  );


  /* ------------------------------
     CART LINK OPENS DRAWER
  ------------------------------ */

  var cartLinks =
    document.querySelectorAll(
      'a[href="/cart"], a[href="' +
      window.Shopify?.routes?.root +
      'cart"]'
    );


  cartLinks.forEach(
    function (link) {

      link.addEventListener(
        'click',
        async function (event) {

          event.preventDefault();

          await renderCart();

          openCartDrawer();

        }
      );

    }
  );

});